












import { Component, Inject, Model, Prop, Vue, Watch, Provide } from "vue-property-decorator";
import Config from '../utils/Config';

@Component({
	components:{}
})
export default class CurrentGoal extends Vue {

	public get elem1():string{
		return Config.STEPS[this.$store.state.room.currentStepIndex].elements[0];
	}
	public get elem2():string{
		return Config.STEPS[this.$store.state.room.currentStepIndex].elements[1];
	}

	public get enabled():boolean {
		return this.$store.state.room.currentStepIndex < Config.STEPS.length;
	}

	public get arrowBackEnabled():boolean {
		return Config.STEPS[this.$store.state.room.currentStepIndex].targets[1] != null;
	}

	public mounted():void {
		
	}

	public beforeDestroy():void {
		
	}

}
